module.exports = require("./../../_gen/starling/styles/MeshStyle");